import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { DataSourceHandler } from '@api/data-source-handler';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import { errorAlert, successAlert } from '@components/toastify/notify-toast';
import { ModelAttribute, ModelList, ProjectData } from '../types';
import styles from "../../../admin/styles.module.scss"
import Form, { InputField, RadioField } from '@components/form';
import { _selectoptionType } from '@components/form/select-field';
import { Flex } from '@components/ui/Flex';
import { ShowWhenTrue } from '@helpers/showwhentrue';
import { isEmpty } from 'lodash';
import { uuid } from 'uuidv4';
import { Modal } from '@components/modals';
import classnames from 'classnames';
import { ProjectForm } from '@pages/admin/project-form';
import ProjectList from '../projectList';
import { DeleteConfirm } from '../confirm';
import { Checkbox } from 'antd-latest';

type CreateModalProps = {
    activeTab: string;
    onCancel: () => void;
    onTabChange: (key: string) => void;
    selectedAsset?: ModelList | null;
    refreshModelList: () => void;
    modelList: ModelList[];
    type: string
}

type AttributeType = 'STRING' | 'NUMBER' | 'Date' | 'BOOLEAN' | 'Dropdown' | 'Entity';

interface Attribute {
    name: string;
    type: AttributeType;
    isRequired: boolean;
    validation: 'none' | 'Regex' | 'min_max';
    value?: string;
}

interface ClassItem {
    className: string;
    superclass: string;
    description: string;
    attributes: Attribute[];
}

const modelFormSchema = yup.object({
    name: yup.string().required('This is a required field'),
    description: yup.string().max(500, 'Description should be less than 10 characters'),
});

const schemaFormSchema = yup.object({
    schemaName: yup.string().required('This is a required field'),
    schemaDes: yup.string().max(500, 'Description should be less than 10 characters'),
    options: yup.string().required('This is a required field'),
    schemaId: yup.number(),
    isa95: yup.boolean()
});

export type ModelFormValues = yup.InferType<typeof modelFormSchema>
export type ModelSchemaFormValues = yup.InferType<typeof schemaFormSchema>

const CreateModal: React.FC<CreateModalProps> = ({ activeTab, onCancel, onTabChange, selectedAsset, modelList, refreshModelList, type }) => {
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);

    const [details, setDetails] = useState<any>({ name: '', description: '', model: [] });
    const [schemaDetails, setSchemaDetails] = useState<any>({ schemaId: null, schemaName: '', schemaDes: '', options: "Asset Hierarchy", isa95: false });
    const [childModels, setChildModels] = useState<ModelList[]>([]);
    const [modelAttribute, setModelAttribute] = useState<ModelAttribute[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedModelAsset, setSelectedModelAsset] = useState<ProjectData | null>(null);
    const [schemaCounter, setSchemaCounter] = useState(1);
    const [showDeletePopup, toggleDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState<ModelList>({} as ModelList);
    const [newClasses, setNewClasses] = useState<ProjectData[]>([]);
    const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
    const [selectedSchemaId, setSelectedSchemaId] = useState<string | null>(null);

    const mapToTreeModel = (models: ModelList[] | undefined, isChild = false): any[] => {
        return models?.map((model) => {
            const isCurrentModelSelected = model.name === details.name;
            const hasSelectedInChildren = (children: ModelList[]): boolean => {
                return children?.some(child =>
                    child.name === details.name ||
                    (child.childModels && hasSelectedInChildren(child.childModels))
                ) || false;
            };

            return {
                title: model.name || model.id.toString(),
                value: isChild ? model.id.toString() + "-" + uuid() : model.id.toString(),
                attributes: model.attributes,
                children: mapToTreeModel(model.childModels, true),
                disabled: isChild || isCurrentModelSelected || hasSelectedInChildren(model.childModels || []),
            };
        }) || [];
    };

    const handleAddNewClass = () => {
        setSelectedModelAsset(null);
        setShowModal(true);
    };


    const handleSubmitAllClasses = () => {
        // console.log('modelAttribute', modelAttribute);
    };


    useEffect(() => {
        if (selectedAsset && type !== "add") {
            setSelectedProjectId(selectedAsset.id.toString());
            setDetails({
                name: selectedAsset.name,
                description: selectedAsset.description,
                // model: selectedAsset.childModels?.map((model) => model.id.toString())
            });
            setSelectedSchemaId(selectedAsset?.schema?.id || null);
            setSchemaDetails({
                schemaName: selectedAsset?.schema?.name,
                schemaDes: selectedAsset?.schema?.description,
                options: selectedAsset?.schema?.type,
                isa95: selectedAsset?.schema?.isa95,
                // superClass: selectedAsset?.superClass
            })
            // setModelAttribute([...modelAttribute, { name: selectedAsset.name, attributes: selectedAsset.attributes }]);
        }
    }, [selectedAsset, type]);

    const handleEdit = (item: any) => {
        setSelectedModelAsset(item);
        setShowModal(true);
    }

    // useEffect(()=>{
    //     if(!isEmpty(selectedProjectId)){
    //         DataSourceHandler.GetProject(
    //             `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
    //             Number(selectedProjectId),
    //             (res) => {
    //                 if (res) {
    //                     setDetails({
    //                         name: res.name,
    //                         description: res.description,
    //                     }); 
    //                     setSelectedSchemaId(res.id);
    //                 }
    //             },
    //             (err: any) => console.error('Error', err)
    //         );
    //     }

    // }, [selectedProjectId]);

    const getNewClasses = (schemaId: number) => {
        DataSourceHandler.GetNewClasses(
            `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
            schemaId,
            (res) => {
                setNewClasses(res);
            },
            (err: any) => console.error('Error', err)
        );
    }

    useEffect(() => {
        if (activeTab === 'attributes' || activeTab === 'schema' && selectedSchemaId !== null) {
            getNewClasses(Number(selectedSchemaId));
        }
    }, [activeTab, schemaDetails?.schemaId]);



    const handleCancel = () => {
        setDetails({ name: '', description: '', type: '', model: [] });
        setSchemaDetails({ schemaId: null, schemaName: '', schemaDes: '', type: '', superclass: '', isa95: false });
        // setAttributes([{ name: '', type: '', isArray: false, value: "", validation: 'none', isRequired: false }]);
        setChildModels([])
        onCancel();
    }


    const checkIfChildSelected = (
        selectedId: string,
        selectedSet: Set<string>,
        childModels: any[]
    ): boolean => {
        for (const child of childModels) {
            if (selectedSet.has(child.id.toString())) {
                // console.log(`Conflict detected: Child "${child.name}" of selected model is already selected.`);
                return true;
            }
            if (checkIfChildSelected(selectedId, selectedSet, child.childModels)) {
                return true;
            }
        }
        return false;
    };

    const checkIfParentSelected = (
        selectedId: string,
        selectedSet: Set<string>,
        modelList: any[]
    ): boolean => {
        for (const model of modelList) {
            if (model.childModels.some((child: any) => child.id.toString() === selectedId)) {
                if (selectedSet.has(model.id.toString())) {
                    // console.log(`Conflict detected: Parent "${model.name}" of selected model is already selected.`);
                    return true;
                }
                if (checkIfParentSelected(model.id.toString(), selectedSet, modelList)) {
                    return true;
                }
            }
        }
        return false;
    };
    const handleDelete = (selectedAsset: any) => {
        setItemToDelete(selectedAsset);
        toggleDeletePopup(true);
    }


    const handleDetailsFormSubmit = (values: ModelFormValues) => {
        setDetails(values);
        try {
            DataSourceHandler.CreateProject(
                `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
                {
                    ...(selectedProjectId ? { id: selectedProjectId } : {}),
                    name: values.name,
                    description: values.description,
                },
                (response) => {
                    if (response) {
                        successAlert(response);
                        setSelectedProjectId(response.id);
                        onTabChange('schema');
                    }
                },
                (response: { data: { message: string; }; }) => {
                    errorAlert(response.data?.message);
                }
            );
        } catch (error) {
            console.error("Error:", error);
        }
    }
    const handleSchemaDetailsFormSubmit = (values: ModelSchemaFormValues) => {
        setSchemaDetails(values);
        try {
            DataSourceHandler.CreateProjectSchema(
                `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
                selectedProjectId,
                {
                    ...(selectedSchemaId ? { id: selectedSchemaId } : {}),
                    name: values.schemaName,
                    description: values.schemaDes,
                    type: values.options,
                    isa95: values.isa95,
                },
                (response) => {
                    if (response) {
                        successAlert(response);
                        setSelectedSchemaId(response.id);
                        if (values?.options === "Asset Hierarchy" && values.isa95 && isEmpty(newClasses)) {
                            const classPromises = ["Enterprise", "Site", "Area", "Work Center", "Work Unit"].map((item) => {
                                const payload = {
                                    name: item,
                                    schemaId: response?.id,
                                    nodeType: "Entity Class",
                                    description: "",
                                    superclass: "",
                                    attributes: [],
                                };

                                return new Promise((resolve, reject) => {
                                    DataSourceHandler.AddNewClass(
                                        `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
                                        payload,
                                        (res) => resolve(res),
                                        (err: any) => reject(err)
                                    );
                                });
                            });

                            Promise.all(classPromises)
                                .then(() => onTabChange('attributes'))
                                .catch(err => console.error('Error creating classes:', err));
                        } else {
                            onTabChange('attributes');
                        }
                    }
                },
                (response: { data: { message: string; }; }) => {
                    errorAlert(response.data?.message);
                }
            );
        } catch (error) {
            console.error("Error:", error);
        }
    }


    const createTabItems = [
        {
            label: 'Details',
            key: 'details',
            children: (
                <Form
                    key={'detailsForm'}
                    initialValues={{ name: details.name, description: details.description, type: details.type, model: details.model }}
                    validationSchema={modelFormSchema}
                    onSubmit={handleDetailsFormSubmit}
                    enableReinitialize
                >
                    {({ _formikprops: { setFieldValue, values } }) => (
                        <>
                            <div className={styles["assetForm"]}>
                                <InputField
                                    name="name"
                                    label="Project Name"
                                    required={true}
                                    // disabled={type === "edit"}
                                    autoComplete="off"
                                    className='mb-0'
                                />
                                <InputField
                                    name="description"
                                    label="Description"
                                    autoComplete="off"
                                    validate={true}
                                    maxLength={501}
                                />

                            </div>
                            <div className={styles['addEditModelModal__actionBtns']}>
                                <button
                                    className="btn btn-lg btn-grey"
                                    type="button"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-lg btn-yellow"
                                    type="submit"
                                >
                                    Save & Next
                                </button>
                            </div>

                        </>
                    )}
                </Form>
            ),
        },
        {
            label: 'Schema',
            key: 'schema',
            children: (
                <Form
                    key={'schemaDetailsForm'}
                    initialValues={{ schemaId: schemaDetails.id, schemaName: schemaDetails.schemaName, schemaDes: schemaDetails.schemaDes, options: schemaDetails.options, isa95: schemaDetails?.isa95 || false }}
                    validationSchema={schemaFormSchema}
                    onSubmit={handleSchemaDetailsFormSubmit}
                    enableReinitialize
                >
                    {({ _formikprops: { setFieldValue, values } }) => (
                        <>
                            <div className={styles["assetForm"]}>
                                <InputField
                                    name="schemaName"
                                    label="Schema Name"
                                    required={true}
                                    // disabled={type === "edit"}
                                    className='mb-0'
                                    autoComplete="off"
                                />
                                <InputField
                                    name="schemaDes"
                                    label="Description"
                                    autoComplete="off"
                                    validate={true}
                                    className='mb-0'
                                    maxLength={501}
                                />
                                <RadioField
                                    name="options"
                                    options={[
                                        { value: "Asset Hierarchy", label: 'Asset Hierarchy' },
                                        { value: "Knowledge Graph", label: 'Knowledge Graph' },
                                    ]}
                                    label='Options'
                                    className='radio-field'
                                />
                                <ShowWhenTrue show={values.options === "Asset Hierarchy"}>
                                    <Checkbox
                                        name='isa95'
                                        className={styles["project-checkbox-isa95"]}
                                        checked={values.isa95}
                                        onChange={(e) => setFieldValue('isa95', e.target.checked)}

                                    >
                                        ISA95
                                    </Checkbox>
                                </ShowWhenTrue>

                            </div>

                            <div className={styles['addEditModelModal__actionBtns']}>
                                <Flex gap='12px'>
                                    <button
                                        className="btn btn-lg btn-grey"
                                        type="button"
                                        onClick={() => onTabChange('details')}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className="btn btn-lg btn-yellow"
                                        type="submit"
                                    >
                                        Save & Next
                                    </button>
                                </Flex>
                            </div>

                        </>
                    )}
                </Form>
            ),
        },
        {
            label: 'Classes',
            key: 'attributes',
            children: (
                <div className={styles['attributes-table-wrapper']}>
                    <div className={styles['sticky-header']}>
                        <div className={styles['top-bar']}>
                            <button
                                className="btn-sm btn-yellow"
                                type="button"
                                onClick={handleAddNewClass}
                            >
                                + Class
                            </button>
                        </div>

                        <div className={styles['divider']}></div>
                    </div>
                    <ProjectList data={newClasses} handleDelete={handleDelete} handleEdit={handleEdit} handleViewClassdata={handleViewClassdata} />

                    <div className={styles['fixed-footer']}>
                        <Flex gap="12px">
                            <button
                                className="btn btn-lg btn-grey"
                                type="button"
                                onClick={() => onTabChange('schema')}
                            >
                                Previous
                            </button>
                            <button

                                className="btn btn-lg btn-yellow"
                                onClick={() => { refreshModelList(); handleCancel() }}
                            >
                                Done
                            </button>
                        </Flex>
                    </div>
                </div>

            ),
        },

    ];

    const onsubmit = (values: any) => {
        const payload = {
            ...values,
            schemaId: selectedSchemaId,
            id: selectedModelAsset?.id,
        };
        DataSourceHandler.AddNewClass(
            `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
            payload,
            (res) => {
                successAlert(res?.msg);
                if (selectedSchemaId !== null) {
                    getNewClasses(Number(selectedSchemaId));
                }
                setShowModal(false);
            },
            (err: any) => console.error('Error', err)
        );
    }

    const deleteModel = (selectedAsset: ModelList) => {
        if (selectedAsset) {
            DataSourceHandler.deleteClasses(`${Env?.REACT_APP_PLATFORM_URL}/asset/api`, Number(selectedAsset.id), () => {
                successAlert("Deleted Successfully.")
                toggleDeletePopup(false);
                getNewClasses(Number(selectedSchemaId));
            });
        }
    }

    return (
        <div>
            <Flex gap='20px'>
                <div className={styles['addEditModelModal__innerContainer']}>
                    <Tabs activeKey={activeTab} onChange={onTabChange} size='large'>
                        {createTabItems.map((tab) => (
                            <Tabs.TabPane disabled tab={tab.label} key={tab.key}>
                                {tab.children}
                            </Tabs.TabPane>
                        ))}
                    </Tabs>
                </div>

            </Flex>
            <Modal
                isOpen={showModal}
                toggleClose={() => setShowModal(false)}
                title="Class & Attributes"
                className={classnames(
                    // 'editConnection_container',
                    styles['addEditProjectModal']
                )}
                shouldCloseOnOverlayClick={false}
            >
                <div className={classnames('projectModalForm', styles['addEditNifiModal__innerContainer'])}>
                    <ProjectForm
                        initialValues={{ name: selectedModelAsset?.name || '', description: selectedModelAsset?.description || '', nodeType: selectedModelAsset?.nodeType || "Entity Class", superclass: selectedModelAsset?.superclass || '', attributes: selectedModelAsset?.attributes || [] }}
                        schemaCheck={schemaDetails?.options == "Asset Hierarchy" ? false : true}
                        newClasses={newClasses}
                        // getNewClasses={()=>getNewClasses(Number(selectedSchemaId))}
                        submitButtons={
                            <div className={styles['addEditNifiModal__projectFormactionBtns']}>
                                <button
                                    className="btn btn-lg"
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-lg btn-yellow"
                                    type="submit"
                                >
                                    Save
                                </button>
                            </div>
                        }
                        onSubmit={onsubmit}
                    />
                </div>

            </Modal>
            <DeleteConfirm
                onConfirm={() => deleteModel(itemToDelete)}
                showModal={showDeletePopup}
                title={`Are you sure you want to delete the ${itemToDelete?.name || ""} Class?` //Model
                }
                toggleClose={() => {
                    toggleDeletePopup(false);
                }}
            />
        </div>
    );
};

export default CreateModal;


function handleViewClassdata(item: ProjectData): void {
    throw new Error('Function not implemented.');
}

